import { getRandomIntInclusive } from '@application/utils';
import check from '@assets/check.svg';
import { CardItem, SkeletonBox } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import * as Styled from './styled';
import type { CardItemArticleProps } from './types';

export * from './types';

export const CardItemArticle: FC<CardItemArticleProps> = (props) => {
  const { image, title, tags = [], reviewed = false, onClick, loading = false, ...rest } = props;
  const { translate } = useTranslation();

  const skeletons = useMemo(() => {
    return {
      titleTop: { width: '100%', height: 21, display: 'block', marginBottom: 10 },
      titleBottom: { width: getRandomIntInclusive(60, 220), height: 21 },
      footerText: { width: getRandomIntInclusive(120, 160), height: 19 },
    };
  }, []);

  if (loading)
    return (
      <CardItem
        loading
        content={{
          title: (
            <>
              <SkeletonBox style={{ ...skeletons.titleTop }} />
              <SkeletonBox style={{ ...skeletons.titleBottom }} />
            </>
          ),
        }}
        footer={<SkeletonBox style={{ ...skeletons.footerText }} />}
      />
    );

  return (
    <CardItem
      image={image}
      badges={
        !reviewed
          ? []
          : [{ color: 'blue', image: check, label: translate('glossary.reviewedArticle') }]
      }
      footer={
        tags.length === 0 ? undefined : (
          <Styled.FooterWrapper>
            {tags.map((tag, index) => (
              <Styled.FooterSpan key={index} color={tag.color}>
                {tag.label}
              </Styled.FooterSpan>
            ))}
          </Styled.FooterWrapper>
        )
      }
      onClick={onClick}
      {...rest}
    >
      <Styled.ContentTitle>{title}</Styled.ContentTitle>
    </CardItem>
  );
};
